import { render, staticRenderFns } from "./InputCompilatore.vue?vue&type=template&id=f4138d0c"
import script from "./InputCompilatore.vue?vue&type=script&lang=js"
export * from "./InputCompilatore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports